import { createEvent, restore, sample } from 'effector'
import { fx, path } from 'src/libs'
import { languages } from '../../../../../libs/languages'
import { $params, toPath } from '../../../../../features/router'
import { WebsiteBannerItem } from '../list/types'
import { getOffers } from '../../offers/list/model'
import { Offer } from '../../offers/list/types'

export const setWebsiteBannerForm = createEvent<WebsiteBannerItem>()

export const websiteBannerMounted = createEvent()

export const offersByLangMounted = createEvent<{ lang: string }>()

export const submitUpdateWebsiteBanner =
  createEvent<Omit<WebsiteBannerItem, 'id' | 'websiteBannerFiles' | 'offer'>>()

export const $websiteBanner = restore(setWebsiteBannerForm, {
  id: 0,
  lang: `${languages[0].value}`,
  title: '',
  offerId: 0,
  isVisible: false,
  offer: {
    title: '',
  },
  websiteBannerFiles: [],
})

export const $offersByLang = restore<Offer[]>(
  getOffers.doneData.map((a) => a.body.items),
  [],
)

export const getWebsiteBannerGroup = fx<void, WebsiteBannerItem>({
  method: 'GET',
  url: '/partner/material/website_banner/{id}',
})

export const updateWebsiteBannerGroup = fx<
  Omit<WebsiteBannerItem, 'id' | 'websiteBannerFiles' | 'offer'>,
  void
>({
  method: 'PUT',
  url: '/partner/material/website_banner/{id}',
})

sample({
  clock: websiteBannerMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.websiteBannerID
    }
    return {
      url: `/partner/material/website_banner/${id}`,
    }
  },
  target: getWebsiteBannerGroup,
})

sample({
  clock: submitUpdateWebsiteBanner,
  source: $params,
  fn: (params, websiteBanner) => {
    let id
    if (params) {
      id = params.websiteBannerID
    }

    return {
      url: `/partner/material/website_banner/${id}`,
      body: { ...websiteBanner },
    }
  },
  target: updateWebsiteBannerGroup,
})

sample({
  clock: [getWebsiteBannerGroup.doneData],
  fn: (doneData) => doneData.body,
  target: [setWebsiteBannerForm, offersByLangMounted],
})

sample({
  clock: [updateWebsiteBannerGroup.doneData],
  target: toPath.prepend(path.ib.ad.banners.entry),
})

sample({
  // @ts-ignore
  clock: offersByLangMounted,
  fn: ({ lang }) => {
    let query = {
      lang,
    }

    return {
      query,
    }
  },
  target: getOffers,
})
